import React, { useRef, useState } from 'react';
import PinInput from 'react-pin-input';
import { Select } from 'antd';
import {
  mascot_img_main,
  logoVoxel,
} from '../../imagepath';
import { Link } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';
import ApiService from '../../../services/ApiService.js';
import apiService from '../../../axios/apiService';

import Loader from '../../../common/loader.jsx';
import { notification, Input } from 'antd';
import { APP_TERMS } from '../../../app-terms.js';
import ReCaptcha from './ReCaptcha.jsx';
import { PRIVACY_POLICY_EXTERNAL_URL } from '../../../appContants.js';
import ReverseTimer from '../../../common/ReverseTimer.jsx';
const Signup = () => {
  const recaptcha = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
    reset,
    getValues,
  } = useForm();
  const initialEmail = location?.state?.email || null;
  const openedFromLogin = !!location?.state?.fromLogin;
  const [formToggle, setFormToggle] = useState(!openedFromLogin);
  const [userName, setUserName] = useState(initialEmail);
  const [isLoading, setIsLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [formData,setFormData] = useState(null);
  const [formDataForOtp,setOtpFormData] = useState(
    openedFromLogin && initialEmail ? { email: initialEmail } : null
  );
  const [timerKey, setTimerKey] = useState(0);
  const [isOtpTimerActive, setIsOtpTimerActive] = useState(openedFromLogin);
  const options = [
    { value: 'Mr', label: 'Mr' },
    { value: 'Mrs', label: 'Mrs' },
    { value: 'Ms', label: 'Ms' },
    { value: 'Dr', label: 'Dr' },
  ];
  const onSubmit = async (data) => {
    try {
      const captchaValue = recaptcha.current.getValue();
      if (!captchaValue) {
        return notification.error({
          message: 'Please verify captcha!',
          showProgress: false,
        });
      } else {
        try {
          setIsLoading(true);
          const data =
            await apiService.verifyCaptchaToken(
              captchaValue
            );
          if (!data.success) {
            return notification.error({
              message: 'Failed',
              description:
                'Captcha verification failed!!',
              showProgress: false,
            });
          }
        } catch (error) {
          setIsLoading(false);
          notification.error({
            message: 'Failed',
            description:
              'Captcha verification failed!!',
            showProgress: false,
          });
          return;
        }
      }
      setIsLoading(true);
      let payload = {
        email: data.email,
        firstName: data.first_name,
        lastName: data.last_name,
        nameTitle: data.title,
        password: data.password,
        clinicName: data.clinic_name,
        clinicAddress: data.address,
        clinicContactNumber: data.contact_no,
        clinicZipcode: data.clinicZipcode,
        agree: data.agree,
      };
      let user = await apiService.signUPClinic(payload);
      setFormData(data);
      setOtpFormData(payload);
      setIsLoading(false);
      if (user) {
        // alert('Rigistration Done Successfully');
        api.success({
          message: 'Success',
          description: 'Rigistration Done Successfully',
          showProgress: false,
          // pauseOnHover,
        });
        setUserName(data.email);
        setFormToggle(false);

        reset();
      }
    } catch (error) {
      api.error({
        message: 'Error',
        description: error.msg,
        showProgress: false,
        // pauseOnHover,
      });
      console.error('Error registering user:', error.msg);
      setIsLoading(false);
    }
  };
  return (
    <>
      {contextHolder}
      <div>
        <div className="main-wrapper login-body">
          <div className="container-fluid px-0">
            <div className="row">
              {/* Login logo */}
              <div className="col-lg-6 login-wrap">
                <div className="login-sec-centered">
                  <div className="log-img">
                    <img className="img-fluid" src={mascot_img_main} alt="Logo" />
                  </div>
                </div>
              </div>
              {/* /Login logo */}
              {/* Login Content */}
              <div className="col-lg-6 login-wrap-bg">
                <div className="login-wrapper">
                  <div className="loginbox" style={formToggle ? { maxHeight: '90vh', overflowY: 'auto' } : {}}>
                    <div className="login-right">
                      <div className="login-right-wrap">
                        <div className="account-logo">
                          <Link to="/admin-dashboard">
                            <img
                              src={logoVoxel}
                              alt="#"
                              style={{ height: 130 }}
                            />
                          </Link>
                        </div>
                        <h2>Clinic Signup</h2>
                        {/* Form */}
                        {/* <form action="./login"> */}
                        {formToggle ? (
                          <form action="./" onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-group">
                              <label
                                style={{
                                  // width: 120,
                                  // marginTop:6
                                  zIndex: 10000,
                                }}
                              >
                                Title <span className="login-danger">*</span>
                              </label>

                              <Controller
                                name="title"
                                control={control}
                                rules={{ required: 'This field is required' }}
                                render={({ field }) => (
                                  <>
                                    <Select
                                      {...field}
                                      className="form-control menu-class"
                                      options={options}
                                      placeholder="Select title"
                                    />
                                    {errors.title && (
                                      <p style={{ color: 'red' }}>
                                        {errors.title.message}
                                      </p>
                                    )}
                                  </>
                                )}
                              />
                              {/* <input className="form-control" type="text" {...register("title", { required: true })}/> */}
                              <small style={{ color: 'red' }}>
                                {errors.title && <p>Please enter Title</p>}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>
                                First Name{' '}
                                <span className="login-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                {...register('first_name', { required: true })}
                              />
                              <small style={{ color: 'red' }}>
                                {errors.first_name && (
                                  <p>Please enter First name</p>
                                )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>
                                Last Name{' '}
                                <span className="login-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                {...register('last_name', { required: true })}
                              />
                              <small style={{ color: 'red' }}>
                                {errors.last_name && (
                                  <p>Please enter Last name</p>
                                )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>
                                Email <span className="login-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                type="email"
                                {...register('email', {
                                  required: 'Please Enter Your Email!',
                                  pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: 'Please enter a valid email'
                                  }
                                })}
                              />
                              <small style={{ color: 'red' }}>
                                {errors.email && <p>{errors.email.message}</p>}
                              </small>
                            </div>
                            <div className="row align-items-start">
                              <div className="col">
                                <div className="form-group">
                                  <label style={{ zIndex: "999" }}>Password <span className="login-danger">*</span></label>

                                  <Controller
                                    name="password"
                                    control={control}
                                    rules={{
                                      required: "Please enter Password",
                                      pattern: {
                                        value: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).+$/,
                                        message: "Password must contain at least 1 capital, 1 number & 1 special char"
                                      }
                                    }}
                                    render={({ field }) => (
                                      <Input.Password {...field} className="custom-password-input" />
                                    )}
                                  />

                                  {errors.password && (
                                    <p style={{ color: 'red' }}>{errors.password.message}</p>
                                  )}
                                {!errors.password && (
                                  <small style={{ color: "#666", fontSize: "12px" }}>
                                  Password must contain at least one capital letter, one number and one special character
                                </small>
                                )}
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-group">
                                  <label style={{ zIndex: "999" }}>Confirm Password <span className="login-danger">*</span></label>

                                  <Controller
                                    name="confirm_password"
                                    control={control}
                                    rules={{
                                      required: "Please enter Confirm Password",
                                      validate: (value) =>
                                        value === getValues("password") || "Passwords should match!"
                                    }}
                                    render={({ field }) => (
                                      <Input.Password {...field} className="custom-password-input" />
                                    )}
                                  />

                                  {errors.confirm_password && (
                                    <p style={{ color: 'red' }}>{errors.confirm_password.message}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="form-group group-background">
                              <label>
                                Clinic Details{' '}
                                <span className="login-danger">*</span>
                              </label>
                              <div className="row align-items-start pt-4 row-border-signup">
                                <div className="form-group">
                                  <label>
                                    Clinic Name{' '}
                                    <span className="login-danger">*</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    {...register('clinic_name', {
                                      required: true,
                                    })}
                                  />
                                  <small style={{ color: 'red' }}>
                                    {errors.clinic_name && (
                                      <p>Please enter Clinic Name</p>
                                    )}
                                  </small>
                                </div>
                                <div className="form-group">
                                  <label>
                                    Contact No{' '}
                                    <span className="login-danger">*</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    {...register('contact_no', {
                                      required: true,
                                    })}
                                  />
                                  <small style={{ color: 'red' }}>
                                    {errors.contact_no && (
                                      <p>Please enter Contact No</p>
                                    )}
                                  </small>
                                </div>
                                <div className="form-group">
                                  <label>
                                    Clinic Address{' '}
                                    <span className="login-danger">*</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    {...register('address', { required: true })}
                                  />
                                  <small style={{ color: 'red' }}>
                                    {errors.address && (
                                      <p>Please enter Clinic Address</p>
                                    )}
                                  </small>
                                </div>
                                <div className="form-group">
                                  <label>
                                    {APP_TERMS.zip_code_title}{' '}
                                    <span className="login-danger">*</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    {...register('clinicZipcode', {
                                      required: true,
                                      pattern: {
                                        value: /^\d{5}(?:[-\s]\d{4})?$/i,
                                        message:
                                          APP_TERMS.zip_code_invalid_validation,
                                      },
                                    })}
                                  />
                                  <small style={{ color: 'red' }}>
                                    {errors?.clinicZipcode?.type ===
                                      'required' && (
                                      <p>
                                        {APP_TERMS.zip_code_required_validation}
                                      </p>
                                    )}
                                  </small>
                                  <small style={{ color: 'red' }}>
                                    {errors?.clinicZipcode?.type ===
                                      'pattern' && (
                                      <p>{errors?.clinicZipcode?.message}</p>
                                    )}
                                  </small>
                                </div>
                              </div>
                            </div>
                            {/* <div className="form-group">
                          <label>
                            Password <span className="login-danger">*</span>
                          </label>
                          <input
                            ref={inputRef}
                            className="form-control pass-input"
                            type="text"
                          />
                          <ReactPasswordToggleIcon
                            inputRef={inputRef}
                            showIcon={showIcon}
                            hideIcon={hideIcon}
                          />
                          <span className="profile-views feather-eye-off toggle-password" />
                        </div> */}
                            {/* <div className="form-group">
                          <label>
                            Confirm Password{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            ref={inputRef2}
                            className="form-control pass-confirm"
                            type="password"
                          />
                          <ReactPasswordToggleIcon
                            inputRef={inputRef2}
                            showIcon={showIcon}
                            hideIcon={hideIcon}
                          /> */}
                            {/* <input
                            className="form-control pass-input-confirm"
                            type="password"
                          /> */}
                            {/* <span className="profile-views feather-eye-off confirm-password" />
                        </div> */}
                            {/* <div>
                        <ReCAPTCHA
                          sitekey="Your client site key"
                          onChange={onChange}
                        />,
                        </div> */}
                            <div className="forgotpass">
                              <div className="remember-me">
                                <label className="custom_check mr-2 mb-0 d-inline-flex remember-me">
                                  {' '}
                                  I agree to the{' '}
                                  <Link to={PRIVACY_POLICY_EXTERNAL_URL} target='blank'>
                                    &nbsp; Terms & Conditions{' '}
                                  </Link>
                                  <input
                                    type="checkbox"
                                    name="agree"
                                    {...register('agree', { required: true })}
                                  />
                                  <span className="checkmark" />
                                </label>
                                <small style={{ color: 'red' }}>
                                  {errors.agree && (
                                    <p>
                                      Please accept the terms of service and
                                      privacy policy
                                    </p>
                                  )}
                                </small>
                                {/* <Link to="/login">&nbsp; Login</Link> */}
                              </div>
                            </div>
                              <ReCaptcha ref={recaptcha}/>
                            <div className="form-group login-btn">
                              <button
                                className="btn btn-primary btn-block"
                                type="submit"
                              >
                                Sign up
                              </button>
                            </div>
                          </form>
                        ) : (
                          <form
                            onSubmit={handleSubmit(async (data) => {
                              // setData(JSON.stringify(data))
                              try {
                                setIsLoading(true);
                                let res = await ApiService.authOtpSignUp(
                                  userName,
                                  data.code
                                );
                                if (res) {
                                  setIsLoading(false);
                                  // alert('user confirmed successfully')
                                  navigate('/');
                                }
                              } catch (error) {
                                console.log('error: ', error);
                              }
                              // setFormToggle(false);
                            })}
                          >
                            {isOtpTimerActive && (
                                <div className="alert py-2 px-3 text-center mb-2">
                                  We just sent a 6 digit code to <strong>{formDataForOtp?.email}</strong>. Use it within 2 minutes to login.
                                </div>
                              )}
                            <div className="form-group">
                              <label>
                                Enter OTP{' '}
                                <span className="login-danger">*</span>
                              </label>
                              <PinInput
                                length={6}
                                initialValue=""
                                // secret = {"false"}
                                // secretDelay={100}
                                onChange={(value, index) => {
                                  console.log('index: ', index);
                                  console.log('value: ', value);
                                }}
                                type="numeric"
                                inputMode="number"
                                style={{ padding: '10px' }}
                                inputStyle={{ borderColor: 'red' }}
                                inputFocusStyle={{ borderColor: 'blue' }}
                                onComplete={async (value) => {
                                  if (value.length) {
                                    try {
                                      setIsLoading(true);
                                      let payload = {
                                        username: userName,
                                        code: value,
                                      };
                                      let res =
                                        await apiService.confirmSignupClinic(
                                          payload
                                        );
                                      if (res) {
                                        setIsLoading(false);
                                        localStorage.setItem('isRegister', 'true');
                                        // alert('user confirmed successfully')
                                        localStorage.setItem('isRegister', 'true');
                                        navigate('/');
                                      }
                                    } catch (error) {
                                      console.log('error: ', error);
                                      api.error({
                                        message: 'Error',
                                        description: error?.message || '',
                                      });
                                    } finally {
                                      setIsLoading(false);
                                    }
                                  }
                                }}
                                autoSelect={true}
                                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                              />
                              {/* Timer code */}
                                                              <ReverseTimer
                                                                key={timerKey} // 👈 ensures re-render when resend succeeds
                                                                duration={10 * 60}
                                                                onExpire={() => console.log('Timer expired')}
                                                                onResend={async () => {
                                                                  try {
                                                                    setIsLoading(true);
                                                                    console.log('✌️formDataForOtp --->', formDataForOtp);
                                                                    const res = await ApiService.signUPClinic(formDataForOtp);
                                                                    console.log('✌️res --->', res);
                                                                    if (res) {
                                                                      console.log('OTP resent successfully');
                                                                      api.success({
                                                                        message: 'OTP Sent',
                                                                        description: 'A new OTP has been sent to your registered email/phone.',
                                                                        showProgress: false,
                                                                      });
                              
                                                                      // 👇 Start counter only AFTER success
                                                                      setTimerKey((prev) => prev + 1);
                                                                      return true;
                                                                    }
                                                                  } catch (err) {
                                                                    api.error({
                                                                      message: 'Error',
                                                                      description: 'Failed to resend OTP!',
                                                                      showProgress: false,
                                                                    });
                                                                    return false;
                                                                  } finally {
                                                                    setIsLoading(false);
                                                                  }
                                                                }}
                                                                onActiveChange={setIsOtpTimerActive}
                                                              />
                                                          {/* Timer code Ends here */}
                              {/* <input ref={inputRef} className="form-control pass-input" type="text" {...register("code", { required: true })}/> */}
                              {/* <ReactPasswordToggleIcon
                            inputRef={inputRef}
                            showIcon={showIcon}
                            hideIcon={hideIcon}
                          /> */}
                              {/* <small  style={{ color: 'red' }}>{errors.code && <p>Please enter OTP</p>}</small> */}
                              {/* <ErrorMessage errors={errors} name="password" /> */}
                              {/* <span className="profile-views feather-eye-off toggle-password" >
                            <FeatherIcon icon="eye-off" />
                          </span> */}
                            </div>
                            <div className="form-group login-btn">
                              {/* <Link to="/admin-dashboard"
                            className="btn btn-primary btn-block"

                          >
                            Login
                          </Link> */}
                              {/* <button className="btn btn-primary btn-block" type="submit">Submit</button> */}
                            </div>
                          </form>
                        )}
                        {/* /Form */}
                        <div className="next-sign">
                          <p className="account-subtitle">
                            Already have account? {!formToggle? <span onClick={() => {reset({...formData});setFormToggle(true)}}><Link>SignUp</Link></span>:<Link to="/">Login</Link>}
                          </p>
                          {/* Social Login */}
                          {/* <div className="social-login">
                          <Link to="#">
                            <img src={}alt="#"/>
                          </Link>
                          <Link to="#">
                            <img src={}alt="#"/>
                          </Link>
                          <Link to="#">
                            <img src={}alt="#"/>
                          </Link>
                        </div> */}
                          {/* /Social Login */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Login Content */}
            </div>
          </div>
        </div>
      </div>
     {isLoading && <Loader />}
    </>
  );
};

export default Signup;
